module.exports = "/assets/dist/images/relaycars_logo.svg?a612d18106b9ee170a5b5f20a9a7e771";